import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button, Menu, Divider, Typography } from '@mui/material';
import { Icon, ExpandedTooltip } from '@livable/saas-react-components';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { TagsFilter } from './tags';
import useStyles from './styles';
import { useStore } from 'src/stores';
export const FilterMenu = observer(_ref => {
  var _store$homeDashboardS, _store$homeDashboardS2, _store$homeDashboardS3;
  let menuTriggerExternal = _ref.menuTriggerExternal,
    sortModel = _ref.sortModel,
    handleChange = _ref.handleChange,
    tagsFilter = _ref.tagsFilter,
    setTagsFilter = _ref.setTagsFilter,
    updateList = _ref.updateList,
    isNavOpen = _ref.isNavOpen;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSecondLevel = _useState2[0],
    setShowSecondLevel = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    anchorEl = _useState4[0],
    setAnchorEl = _useState4[1];
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const MenuTriggerInternal = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, t('general.to_do')), /*#__PURE__*/React.createElement(Icon, {
      type: "triangle-down"
    }));
  };
  return /*#__PURE__*/React.createElement("span", {
    onClick: e => e.stopPropagation(),
    onKeyDown: e => e.stopPropagation(),
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: t('general.sort_and_filter'),
    key: 'company_selector_sort_and_filter_btn' + ((_store$homeDashboardS = store.homeDashboardStore) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.enableShortcutsHintState),
    placement: (_store$homeDashboardS2 = store.homeDashboardStore) !== null && _store$homeDashboardS2 !== void 0 && _store$homeDashboardS2.enableShortcutsHintState ? 'left' : 'top',
    type: "info",
    open: isNavOpen && ((_store$homeDashboardS3 = store.homeDashboardStore) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.enableShortcutsHintState) || undefined
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    className: classes.filterDropdown,
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "resident menu",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    'custom-attribute': '655-new-billing-module'
  }, menuTriggerExternal !== undefined ? menuTriggerExternal : /*#__PURE__*/React.createElement(MenuTriggerInternal, null))), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, !showSecondLevel ? /*#__PURE__*/React.createElement("div", null, sortModel !== 'asc' && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    className: classes.sortAscOption,
    onClick: event => {
      event.stopPropagation();
      handleChange('asc');
      handleClose();
    },
    'custom-attribute': '656-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, 'Sort ASC')), sortModel !== 'desc' && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: event => {
      event.stopPropagation();
      handleChange('desc');
      handleClose();
    },
    'custom-attribute': '657-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, 'Sort Desc')), sortModel !== 'unsort' && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: event => {
      event.stopPropagation();
      handleChange('unsort');
      handleClose();
    },
    'custom-attribute': '658-new-billing-module'
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, 'Unsort')), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Button, {
    className: classes.filterByPortfoliosOption,
    variant: "menuAction",
    onClick: event => {
      event.stopPropagation();
      setShowSecondLevel(true);
    },
    'custom-attribute': '659-new-billing-module'
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, 'Filter by tags'), /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-line-right"
  }))) : /*#__PURE__*/React.createElement(TagsFilter, {
    handleClose: handleClose,
    tagsFilter: tagsFilter,
    updateList: updateList,
    setTagsFilter: setTagsFilter,
    handleCloseFilter: () => setShowSecondLevel(false)
  })));
});